const IGNORED_WORDS = new Set([
    'DE', 'DEL', 'LA', 'LAS', 'LOS', 'EL', 'Y',
    'MC', 'MAC', 'VAN', 'VON', 'DA', 'DI', 'DO', 'DU'
]);

const COMMON_FIRST_NAMES = new Set([
    'JOSE',
    'MA',
    'MARIA'
]);

function normalize(text = '') {
    return text
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/Ñ/g, 'N')
        .toUpperCase()
        .trim();
}

function inePair(text) {
    if (!text) return 'XX';

    const original = text.toUpperCase().trim();
    const words = original.split(/\s+/);
    const filtered = words.filter(w => !IGNORED_WORDS.has(w));
    const cleaned = (filtered.length ? filtered.join(' ') : words.join(' ')).replace(/[^A-ZÑ]/g, '');
    
    if (!cleaned) return 'XX';

    const first = cleaned.charAt(0);
    const rest = cleaned.slice(1);

    const consonant = rest.split('').find(c => !'AEIOUÑ'.includes(c));

    return (first + (consonant || rest.charAt(0) || 'X')).replace(/Ñ/g, 'N');
}

function getNamePairs(name) {
    const words = normalize(name).split(/\s+/).filter(w => !IGNORED_WORDS.has(w));
    if (!words.length) return ['XX'];

    const first = words[0];
    const isAmbiguous = first.length === 1 || COMMON_FIRST_NAMES.has(first);

    if (isAmbiguous) {
        const results = new Set();
        const second = words[1] || '';

        results.add(first.charAt(0) + 'X');
        if (first.length === 2) results.add(first);

        if (second) {
            const clean = normalize(second).replace(/[^A-Z]/g, '');
            const consonant = clean.split('').find(c => !'AEIOU'.includes(c));
            const vowel = clean.split('').find(c => 'AEIOU'.includes(c));

            if (consonant) results.add(first.charAt(0) + consonant);
            if (vowel) results.add(first.charAt(0) + vowel);
            results.add(inePair(second));
        } else {
            // Si no hay segundo nombre, usar el par del primer nombre
            results.add(inePair(first));
        }

        return Array.from(results);
    }

    return [inePair(first)];
}

function generateAllINEKeys(firstSurname, secondSurname, name) {
    const p1 = inePair(firstSurname);
    const p2 = secondSurname ? inePair(secondSurname) : 'XX';
    const namePairs = getNamePairs(name);

    return namePairs.map(p3 =>
        (p1 + p2 + p3).substring(0, 6)
    );
}

const IneValidator = {
    validateNameMatch(electorKey, name, firstLastName, secondLastName) {
        if (!electorKey || electorKey.length < 6) return null;

        const keyPart = electorKey.substring(0, 6);
        const validKeys = generateAllINEKeys(
            firstLastName,
            secondLastName,
            name
        );

        return validKeys.includes(keyPart);
    }
};

export default IneValidator;
